import React from "react";
import Pill from "./PillElement";

export const HiddenFromMobileApp = () => {
  return <Pill
    color="purple"
    label={RESX.FreeField.HiddenFromMobileApp}
  />
}